import React, {useContext } from "react";
import "./Article.scss";
import {articleSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Article() {
  const {isDark, articles} = useContext(StyleContext);

  if (!articleSection.display || !articles) {
    return null;
  }
    
  return (
    // <div class="badge-base LI-profile-badge" data-locale="en_US" data-size="medium" data-theme="light" data-type="VERTICAL" data-vanity="sarthak-kumar-shailendra" data-version="v1"><a class="badge-base__link LI-simple-link" href="https://in.linkedin.com/in/sarthak-kumar-shailendra?trk=profile-badge">Sarthak Kumar Shailendra</a></div> 
    <div className="main" id="articles">
      <div>
        <Fade bottom duration={1000} distance="20px">
            <div>
            <h1
                className={
                    isDark
                    ? "dark-mode heading achievement-heading"
                    : "component-heading"
                }
                >
                {articleSection.title}
            </h1>
            <p
            className={
                isDark
                ? "dark-mode subTitle achievement-subtitle"
                : "subTitle component-subtitle"
            }
            >
                {articleSection.subtitle}
            </p>
            </div>
        </Fade>
      </div>
        <div className="articles-container">
            <Fade right duration={1500} distance="20px">
                {articles.map((article, i) => {
                    return (
                        <div
                            className={
                                isDark
                                ? "dark-mode article-card article-card-dark"
                                : "component-card"
                            }
                        >
                            {article?.social_image ? (
                                    <img
                                        src={article.social_image}
                                        alt={article.title}
                                        className="article-image"
                                    ></img>
                            ) : null}
                            <div className="article-detail article-padding">
                                {/* <h5
                                    className={isDark ? "dark-mode card-title" : "card-title"}
                                >
                                    {article.title}
                                </h5> */}
                                <p
                                    className={
                                        isDark ? "dark-mode card-subtitle" : "card-subtitle article-subtitle"
                                    }
                                >
                                    {article.description}
                                <div
                                    onClick={()=>{
                                        window.open(article?.url, "_blank")}
                                    } 
                                    className="article-click"
                                >   READ MORE
                                </div>
                                </p>
                            </div>
                        </div> 
                    )})
                }   
            </Fade>    
        </div>
    </div>
  );
}
